(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-mosaic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover)');
    const mobileLayout = window.matchMedia('(max-width: 989px)');

    const getVideoLink = (target) =>
      target instanceof Element ? target.closest('[data-mosaic-video-link]') : null;

    const playVideo = (link) => {
      if (!link || reducedMotion.matches) return;
      const video = link.querySelector('video');
      if (!video) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => link.classList.add('is-playing'))
          .catch(() => link.classList.remove('is-playing'));
      }
    };

    const pauseVideo = (link) => {
      if (!link) return;
      const video = link.querySelector('video');
      if (!video) return;
      video.pause();
      link.classList.remove('is-playing');
    };

    document.addEventListener('pointerover', (event) => {
      if (!desktopHover.matches || reducedMotion.matches) return;
      const link = getVideoLink(event.target);
      if (!link || (event.relatedTarget && link.contains(event.relatedTarget))) return;
      playVideo(link);
    });

    document.addEventListener('pointerout', (event) => {
      if (!desktopHover.matches) return;
      const link = getVideoLink(event.target);
      if (!link || (event.relatedTarget && link.contains(event.relatedTarget))) return;
      pauseVideo(link);
    });

    document.addEventListener('click', (event) => {
      if (!mobileLayout.matches || reducedMotion.matches) return;
      const link = getVideoLink(event.target);
      if (!link) return;
      const video = link.querySelector('video');
      if (!video || !video.paused) return;
      event.preventDefault();
      playVideo(link);
    });

    const stopMotion = (event) => {
      if (!event.matches) return;
      document.querySelectorAll('[data-mosaic-video-link]').forEach(pauseVideo);
    };

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', stopMotion);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(stopMotion);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
